<template>
  <div class="scanWechat">
    <div class="scan-title">
      <SvgIcon
        style="width: 24px; height: 24px; margin-right: 7px;"
        :iconClass="'wechatActive'"
      />
      <p style="margin-bottom: 0">使用微信扫一扫登录</p>
    </div>
    <div class="comp">
      「乐私塾」
    </div>
    <div id="qrcode"></div>
  </div>
</template>

<script>
import SvgIcon from '@/components/SvgIcon'
import { getWxLoginString, wxLogin, getStuInfo } from '@/api/user'
import { mapState } from 'vuex'
import Vue from 'vue'
export default {
  components: { SvgIcon },
  data () {
    return {}
  },
  watch: {
    async $route() {
      const authCode = this.getWechatAuthCode()
      if (authCode) {
        try {
          const res = await this.wechatLogin(authCode)
          res && this.$message.success('登录成功')
          this.$router.push({ name: 'study', replace: true, query: { ocode: Vue.ls.get('code') } })
        } catch (error) {
          this.$router.push({ path: '/user/login', replace: true })
        }
      }
    }
  },
  async created() {
    const authCode = this.getWechatAuthCode()
     console.log('authCode', authCode)
     if (authCode) {
        try {
          const res = await this.wechatLogin(authCode)
          console.log('res', res)
          res && this.$message.success('登录成功')
          this.$router.push({ name: 'study', replace: true, query: { ocode: Vue.ls.get('code') } })
        } catch (error) {
          this.$router.push({ path: '/user/login', replace: true, query: { ocode: Vue.ls.get('code') } })
       }
        return
     }
    console.log('this.info.ocode', this.info.ocode)
    const res = await getWxLoginString({ ocode: this.info.ocode })
    console.log('登录1', res)
     res.redirectUri = 'https://learn.51lss.com/user/wechatLogin'
    this.initQrCode({ ...res })
  },
  computed: {
    ...mapState({
      info: state => state.system.orgInfo
    })
  },
  methods: {
    // 获取回调code
    getWechatAuthCode() {
      let code = ''
      if (!location.hash && !location.search) return code
      const paramsPart = location.hash
        ? `?${location.hash.split('?')[1] || ''}`
        : location.search

      const searchPms = new URLSearchParams(paramsPart)
      code = searchPms.get('code') || ''
      return code
    },
    /**
     * 初始化微信扫码登录二维码
     * @param { Object } params 扫码登录设置项
     */
    initQrCode (params) {
      const _this = this
      if (!window.WxLogin) {
        const wScript = document.createElement('script')
        wScript.type = 'text/javascript'
        wScript.src = 'https://res.wx.qq.com/connect/zh_CN/htmledition/js/wxLogin.js'
        document.body.appendChild(wScript)
      }
      setTimeout(function () {
        const { redirectUri = location.href, appId = '' } = params

        const redirecturi = _this.info.ocode
          ? `${redirectUri}#${_this.info.ocode}`
          : redirectUri
        console.log('redirecturi', redirecturi)
        const data = {
          id: 'qrcode', // wx组建元素
          appid: appId || 'wx29df246f3d732e97', // 微信平台开放id
          scope: 'snsapi_login',
          style: 'black', // 黑白样式
          redirect_uri: encodeURIComponent(redirecturi), // 回调地址 encodeURIComponent编码
          href:
            'data:text/css;base64,LmltcG93ZXJCb3ggLnFyY29kZSB7d2lkdGg6IDIwMHB4O30KLmltcG93ZXJCb3ggLnRpdGxlIHtkaXNwbGF5OiBub25lO30KLmltcG93ZXJCb3ggLmluZm8ge3dpZHRoOiAyMTBweDt9Ci5pbXBvd2VyQm94IC5pY29uMzhfbXNnLnN1Y2Mge2Rpc3BsYXk6IG5vbmV9Ci5pbXBvd2VyQm94IC5pY29uMzhfbXNnLndhcm4ge2Rpc3BsYXk6IG5vbmV9Ci5pbXBvd2VyQm94IC5zdGF0dXMge3RleHQtYWxpZ246IGNlbnRlcjt9Cg=='
        }
        console.log(data, '4567890')
        // eslint-disable-line
        _this.wxloginIns = new window.WxLogin(data)
        console.log('_this.wxloginIns', _this.wxloginIns)
      }, 500)
    },
    async wechatLogin(code) {
      const res = await wxLogin({ code, ocode: this.info.ocode })
      console.log('登录', res)
      const { accessToken: token } = res.token
      this.$store.commit('SET_TOKEN', token)
      const resInfo = await getStuInfo()
      this.$store.commit('SET_USER_INFO', resInfo)
      this.$store.commit('SET_AUDITION', res.isAudition || '')
      return true
    }
  }
}
</script>

<style lang="less">
.scanWechat {
  width: 100%;
  height: 100%;
  overflow: hidden;
  display: flex;
  align-items: center;
  flex-direction: column;
  justify-content: center;
  .scan-title {
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 17px;
    color: #303133;
  }
  .comp {
    margin: 24px 0;
    text-align: center;
    font-size: 22px;
    font-weight: 500;
    color: #303133;
  }
}
</style>
